export const BREAKPOINTS = {
  xl: 1440,
  lg: 1240, //pc
  md: 905, //regular tablet
  sm: 600,
  xs: 340,
};
